import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { buildListQuery, ListQueryOptions, normalizePaginatedListResponse, PaginatedApiResponse } from '../../../services/paginatedList';
import type { CrewQuestionnaireKind } from '../crew-questionnaire-kinds/useData';
import { moduleConfig } from './config';

export type AnswerType = 'SCALE' | 'YES_NO_NA' | 'TEXT';
export interface CrewQuestionnaireQuestion { id?: number; code: string; label: string; helpText?: string | null; answerType: AnswerType; scaleMin?: number | null; scaleMax?: number | null; scaleStep?: number | null; sortOrder: number; isRequired: boolean; isActive: boolean; }
export interface CrewQuestionnaire { id: number; kindId: number; kind?: CrewQuestionnaireKind; name: string; description?: string | null; sortOrder: number; isActive: boolean; questions?: CrewQuestionnaireQuestion[]; createdAt: string; updatedAt: string; }

export const useCrewQuestionnaires = (
  search?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions | null,
) => {
  const enabled = options !== null;
  const query = buildListQuery(search, page, limit, options ?? undefined);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<CrewQuestionnaire> | CrewQuestionnaire[]>(
    enabled ? `${moduleConfig.module.api.list}${query}` : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse(data, page, limit);
  return { ...normalized, clients: normalized.data, isLoading: enabled && isLoading, isError: error, mutate };
};
export const useCrewQuestionnaire = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CrewQuestionnaire>(id ? moduleConfig.module.api.detail(id) : null, fetcher, { revalidateOnFocus: true });
  return { data, item: data, isLoading, isError: error, mutate };
};
export const useQuestionnaireKinds = () => {
  const { data, error, isLoading } = useSWR<PaginatedApiResponse<CrewQuestionnaireKind> | CrewQuestionnaireKind[]>('/crew-questionnaires/kinds?limit=200', fetcher);
  return { data: normalizePaginatedListResponse(data, 1, 200).data, isLoading, isError: error };
};
